import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { RegisterRoutingModule } from './register.routing';
import { RegisterComponent } from '../register/register.component';
import { SharedModule } from '../../shared/shared.module';
import { RegisterService } from './register.service';
@NgModule({
    declarations: [
        RegisterComponent
    ],
    imports: [RegisterRoutingModule, SharedModule, ReactiveFormsModule, FormsModule, CommonModule],
    providers: [RegisterService],
    bootstrap: []
})
export class RegisterModule {
}




// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/register/register.module.ts